import React, { useEffect, useState } from 'react'
import { AppBar, Toolbar, Box, IconButton } from '@mui/material'
import { Link } from 'react-scroll'
import Sidebar from './side-bar'
import MenuIcon from '@mui/icons-material/Menu'
import NAV_LINKS from './nav-link'

export default function Navbar() {
  const [y, setY] = useState(window.scrollY)
  const [sidebarOpen, toggleSidebar] = useState(false)

  useEffect(() => {
    const handleScroll = () => setY(window.scrollY)
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [y])

  return (
    <>
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <AppBar position='fixed' style={{ backgroundColor: 'white' }}>
        <Toolbar style={{ justifyContent: 'space-between' }}>
          <Box padding={0.5}>
            <Link to='aboutus' smooth={true}>
              <img src='/assets/HockTyreLogo.png' height={40} alt='Logo' />
            </Link>
          </Box>
          <Box display={{ xs: 'block', md: 'none' }}>
            <IconButton onClick={() => toggleSidebar(!sidebarOpen)}>
              <MenuIcon />
            </IconButton>
          </Box>
          <Box display={{ xs: 'none', md: 'block' }}>
            {NAV_LINKS.map(({ id, offset, label }) => (
              <Link
                key={id}
                offset={offset}
                style={{
                  color: 'black',
                  textDecoration: 'none',
                  margin: '0 10px',
                  cursor: 'pointer',
                  fontWeight: '1000',
                  fontFamily: 'Gothic',
                  fontSize: '0.875rem',
                  lineHeight: '1.75',
                  transition: 'color 0.3s',
                  padding: '6px 8px',
                }}
                to={id}
                smooth={true}
                activeStyle={{
                  borderBottom: '2px solid #1d4ed8',
                  color: '#1d4ed8',
                }}
                spy={true}
              >
                {label}
              </Link>
            ))}
          </Box>
        </Toolbar>
      </AppBar>
    </>
  )
}
